import React, { useState } from "react";
import { ScalableImage, Typography, useDevice } from "design_system/src";
import { Link } from "react-router-dom";
import useAlliance from "hooks/useAlliance";
import { formatPrice } from "helpers/formatPrice";
import { prices } from "helpers/prices";
import { TSku } from "../../models/inventory/interfaces/sku.interface";
import styles from "./CardVehicle.module.scss";
import HelperCard from "./HelperCard";

type CardSkuProps = {
  sku?: TSku;
  isHelperCard: boolean;
  triggerCard?: any;
};

const CardSku: React.FC<CardSkuProps> = ({
  sku,
  isHelperCard,
  triggerCard,
}) => {
  const { catalogBaseUrl } = useAlliance();
  const { isMobile } = useDevice();

  const [isHovering, setIsHovering] = useState(false);

  const handleMouseOver = () => {
    setIsHovering(true);
  };

  const handleMouseLeave = () => {
    setIsHovering(false);
  };

  return (
    // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
    <div
      className={`${styles.CardVehicle}${isHovering ? ` ${styles["CardVehicle--hovering"]}` : ""}`}
      style={{ height: "100%" }}
      onMouseOver={handleMouseOver}
      onMouseLeave={handleMouseLeave}
    >
      {isHelperCard && (
        <HelperCard
          triggerCard={triggerCard}
          isHovering={isHovering}
          isMobile={isMobile}
        />
      )}

      {!isHelperCard && sku && (
        <Link to={`${catalogBaseUrl}/${sku?.code}`} className="custom_a">
          <div className="display_flex flex_col_desktop pos_relative">
            <div className={`${styles.CardVehicleImgBox}`}>
              <figure className={`${styles.CardVehicleFigure} m_none pos_relative`}>
                <ScalableImage
                  className={styles.CardVehicleImg}
                  src={sku?.images && sku?.images[0]?.url}
                  alt={`Moto ${sku?.brandName} ${sku?.modelName} de ${sku?.cc}cc, año ${sku?.year}, desde $${formatPrice(prices(sku?.minPrice), "")}`}
                  desktopWidth={10}
                  mobileWidth={10}
                />
              </figure>
            </div>
            <div className={`${styles.CardVehicleInfo} display_flex flex_col p_x_md p_b_md`}>
              <div className="p_t_xs p_t_md_desktop">
                <Typography
                  scale="medium"
                  weight="600"
                  className="m_none text_neutral_800"
                  component="h3"
                >
                  {sku?.brandName} {`${sku?.modelName} ${sku?.version ? sku.version : ""}`}
                </Typography>
              </div>

              <div className="p_t_xxs text_neutral_800">
                <Typography
                  scale="small"
                  weight="400"
                  className="p_r_xxs m_r_xxs"
                >
                  {sku?.year} · {sku?.cc} CC
                </Typography>
              </div>

              <div className="w_100_per border_1 border_solid border_neutral_400 m_t_xs" />

              <div className="m_t_xs w_100_per">
                <Typography
                  scale="xsmall"
                  scaleMobile="small"
                  weight="400"
                  component="p"
                  className="m_none text_neutral_800"
                >
                  Precio desde:
                </Typography>
                <Typography
                  scale="heading3"
                  weight="600"
                  scaleMobile="heading4"
                  component="p"
                  className="m_none"
                >
                  ${formatPrice(prices(sku?.minPrice), "")}
                </Typography>
              </div>
            </div>
          </div>
        </Link>
      )}
    </div>
  );
};

export default CardSku;
